// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"953cbe9a","455":"55372804","855":"fb1317ac","977":"240addac"}[chunkId] + ".chunk.js";
};